const constantes = {
    // baseUrl: 'https://speech-text-speech-textteste.azurewebsites.net/api/',
    baseUrl: window.origin.includes('localhost:') ? 'http://localhost:5109/api/' : `${window.origin}/api/`,
    localStoragePrefix: 'r1-',
    audioMarcaVocal: 'r1-audio-marca-vocal-',
};

export default constantes;
